<template>
    <div>   
        <header id="header" class="header header-hide">
          <b-navbar toggleable="sm" type="light" style="padding: 0">
            <b-container style="background-color: white;padding: 8px 16px">
              <b-navbar-brand id="logo">
                <a href="#body" class="scrollto"><span>Nefro</span>Atlas</a>
              </b-navbar-brand>

              <b-navbar-toggle target="nav-text-collapse"></b-navbar-toggle>

              <b-collapse id="nav-text-collapse" is-nav>
                <b-navbar-nav class="ml-auto nav-menu">
                  <li>
                    <router-link class="active" to="/">
                      Home 
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/about">
                      Sobre
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/login">
                      login <span> <log-in-icon size="1x"></log-in-icon> </span>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/cadastro">
                      Cadastro <span> <user-plus-icon size="1x"></user-plus-icon> </span>
                    </router-link>
                  </li>
                </b-navbar-nav>
              </b-collapse>
            </b-container>
          </b-navbar>
        </header>


        <!--==========================
            Hero Section
        ============================-->
        <section id="hero" class="wow fadeIn">
            <div class="hero-container">
              <h1>
                Bem vindo ao <span class="nefro">Nefro</span><span class="atlas">Atlas</span>
              </h1>
              <h2>
                Plataforma para ensino e aprendizado de Nefrologia
              </h2>
              <img src="../assets/hero-img.png" class="hero-img" alt="Hero Imgs">
              <router-link to="/login" class="btn-get-started scrollto">
                COMEÇAR
              </router-link>
              <div class="btns">
                  <a href="#" class="plataforma"><img src="../assets/svg/apple.svg" width="20" alt="apple" style="margin-bottom: 5px"> Apple Store</a>
                  <a href="#" class="plataforma"><img src="../assets/svg/google-play.svg" width="20" alt="google-play" style="margin-bottom: 5px"> Google Play</a>
                  <a href="#" class="plataforma"><img src="../assets/svg/windows.svg" width="20" alt="windows" style="margin-bottom: 5px"> windows</a>
              </div>
            </div>
        </section><!-- #hero -->

        <!--==========================
            Get Started Section
        ============================-->
        <section id="get-started" class="padd-section text-center wow fadeInUp" style="padding-top: 64px">

            <div class="container">
            <div class="section-title text-center">

                <h2>Simples e eficiente</h2>
                <p class="separator">conheça o que nossa plataforma tem de melhor</p>

            </div>
            </div>

            <div class="container">
            <div class="row">

                <div class="col-md-6 col-lg-4">
                  <div class="feature-block">

                      <img src="../assets/svg/feather/check-circle.svg" alt="img" class="img-fluid">
                      <h4>Conteúdo revisado</h4>
                      <p>
                        Conteúdo dedicado para melhor seu conhecimento e preparação 
                      </p>
                      <!-- <a href="#">read more</a> -->

                  </div>
                </div>

                <div class="col-md-6 col-lg-4">
                  <div class="feature-block">

                      <img src="../assets/svg/feather/clock.svg" alt="img" class="img-fluid">
                      <h4>Fácil acesso</h4>
                      <p>
                        Não perca mais tempo procurando, todo conteúdo necessário está aqui!!
                      </p>
                      <!-- <a href="#">read more</a> -->

                  </div>
                </div>

                <div class="col-md-6 col-lg-4">
                  <div class="feature-block">

                      <img src="../assets/svg/feather/smartphone.svg" alt="img" class="img-fluid">
                      <h4>Baixe o app ( Em breve )</h4>
                      <p>Tenha acesso a nossa plataforma de onde você estiver, baixe nosso app</p>
                      <!-- <a href="#">read more</a> -->

                  </div>
                </div>

            </div>
            </div>

        </section>


        <!--==========================
            Features Section
        ============================-->

        <section id="features" class="padd-section text-center wow fadeInUp">

            <div class="container">
              <div class="section-title text-center">
                  <h2>Nossos diferenciais</h2>
                  <!-- <p class="separator">Integer cursus bibendum augue ac cursus .</p> -->
              </div>
            </div>

            <div class="container">
            <div class="row">

                <div class="col-md-6 col-lg-3">
                  <div class="feature-block">
                      <img src="../assets/svg/filechecked.png" alt="img" class="img-fluid"> 
                      <h4>Conteúdo confiável</h4>
                      <p>Elaborado e revisado por médicos especialistas na área e ligados ao Ensino Médico</p>
                  </div>
                </div>

                <!-- <div class="col-md-6 col-lg-3">
                  <div class="feature-block">
                      <img src="../assets/svg/vector.svg" alt="img" class="img-fluid">
                      <h4>Retina Ready</h4>
                      <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                  </div>
                </div> -->

                <div class="col-md-6 col-lg-3">
                  <div class="feature-block">
                      <img src="../assets/svg/design-tool.svg" alt="img" class="img-fluid">
                      <h4>Fácil de usar</h4>
                      <p>Navegação simples, uma vez usando, tenha o conteúdo em mãos</p>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="feature-block">
                      <img src="../assets/svg/cloud-computing.svg" alt="img" class="img-fluid">
                      <h4>Atualizações</h4>
                      <p>Nossa equipe está buscando sempre melhorias em todos os aspectos</p>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="feature-block">
                      <img src="../assets/svg/feather/graph.svg" alt="img" class="img-fluid">
                      <h4>Learn Analytics</h4>
                      <p>Tenha estatísticas de seus estudos para acompanhar seu desempenho</p>
                  </div>
                </div>

                <!-- <div class="col-md-6 col-lg-3">
                  <div class="feature-block">
                      <img src="../assets/svg/feather/email.png" alt="img" class="img-fluid">
                      <h4>Suporte Ativo</h4>
                      <p>Equipe sempre a disposição para responder as dúvidas e resolver problemas</p>
                  </div>
                </div> -->

                <!-- <div class="col-md-6 col-lg-3">
                  <div class="feature-block">
                      <img src="../assets/svg/pixel.svg" alt="img" class="img-fluid">
                      <h4>Perfect Pixel</h4>
                      <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3">
                  <div class="feature-block">
                      <img src="../assets/svg/code.svg" alt="img" class="img-fluid">
                      <h4>clean codes</h4>
                      <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                  </div>
                </div> -->

            </div>
            </div>
        </section>

        <!--==========================
            Team Section
        ============================-->
        <!-- <section id="team" class="padd-section text-center wow fadeInUp">

            <div class="container">
            <div class="section-title text-center">

                <h3 style="font-weight: lighter!important; font-family: 'Roboto', sans-serif;">DESENVOLVEDORES</h3>

            </div>
            </div>

            <div class="container">
            <div class="row">

                <div class="col-md-6 col-md-4 col-lg-3">
                <div class="team-block bottom">
                    <img src="../assets/team/1.jpg" class="img-responsive" alt="img">
                    <div class="team-content">
                    <ul class="list-unstyled">
                        <li><a href="#"><img src="../assets/svg/feather/facebook.svg" alt="facebook" width="5" height="5"></a></li>
                        <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                        <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
                    </ul>
                    <span>manager</span>
                    </div>
                </div>
                </div>

            <div class="col-md-6 col-md-4 col-lg-3">
                <div class="team-block bottom">
                    <img src="../assets/team/2.jpg" class="img-responsive" alt="img">
                    <div class="team-content">
                    <ul class="list-unstyled">
                        <li><a href="#"><img src="../assets/svg/feather/facebook.svg" alt="facebook" width="5" height="5"></a></li>
                        <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                        <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
                    </ul>
                    <span>manager</span>
                    <h4>Kimberly Tran</h4>
                    </div>
                </div>
                </div>

                <div class="col-md-6 col-md-4 col-lg-3">
                <div class="team-block bottom">
                    <img src="../assets/team/3.jpg" class="img-responsive" alt="img">
                    <div class="team-content">
                    <ul class="list-unstyled">
                        <li><a href="#"><img src="../assets/svg/feather/facebook.svg" alt="facebook" width="5" height="5"></a></li>
                        <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                        <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
                    </ul>
                    <span>manager</span>
                    <h4>Kimberly Tran</h4>
                    </div>
                </div>
                </div>

                <div class="col-md-6 col-md-4 col-lg-3">
                <div class="team-block bottom">
                    <img src="../assets/team/4.jpg" class="img-responsive" alt="img">
                    <div class="team-content">
                    <ul class="list-unstyled">
                        <li><a href="#"><img src="../assets/svg/feather/facebook.svg" alt="facebook" width="5" height="5"></a></li>
                        <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                        <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
                    </ul>
                    <span>manager</span>
                    <h4>Kimberly Tran</h4>
                    </div>
                </div>
                </div>

            </div>
            </div>
        </section> -->

        <!--==========================
            Sponsors Section
        ============================-->
        <section id="team" class="padd-section text-center wow fadeInUp">

            <div class="container">
              <div class="section-title text-center">

                  <h3 style="font-weight: lighter!important; font-family: 'Roboto', sans-serif;">PARCEIROS</h3>

              </div>
            </div>

            <div class="container">
              <div class="row">

                <div class="col-md-6 col-md-4 col-lg-3">
                  <div class="team-block bottom">
                      <img src="../assets/colaboradores/ufrn.png" class="img-responsive" alt="img">
                      <div class="team-content">
                      <span>Universidade Federal do Rio Grande do Norte</span>
                      </div>
                  </div>
                </div>

                <div class="col-md-6 col-md-4 col-lg-3">
                  <div class="team-block bottom">
                      <img src="../assets/colaboradores/huol.png" class="img-responsive" alt="img">
                      <div class="team-content">
                      <span>Hospital Universitario Onofre Lopes</span>
                      </div>
                  </div>
                </div>

                <div class="col-md-6 col-md-4 col-lg-3">
                  <div class="team-block bottom">
                      <img src="../assets/colaboradores/ufma.png" class="img-responsive" alt="img">
                      <div class="team-content">
                      <span>Universidade Federal do Maranhão</span>
                      </div>
                  </div>
                </div>

                <div class="col-md-6 col-md-4 col-lg-3">
                  <div class="team-block bottom">
                      <img src="../assets/colaboradores/mpes.png" class="img-responsive" alt="img">
                      <div class="team-content">
                      <span>Mestrado Profissional em Ensino na Saúde</span>
                      </div>
                  </div>
                </div>

                <div class="col-md-6 col-md-4 col-lg-3">
                  <div class="team-block bottom">
                      <img src="../assets/colaboradores/lime.png" class="img-responsive" alt="img">
                      <div class="team-content">
                      <span>Laboratorio de Imunofluorescência e Microscopia Eletrônica</span>
                      </div>
                  </div>
                </div>

                <div class="col-md-6 col-md-4 col-lg-3">
                  <div class="team-block bottom">
                      <img src="../assets/colaboradores/imd.png" class="img-responsive" alt="img">
                      <div class="team-content">
                      <span>Instituto Metropole Digital</span>
                      </div>
                  </div>
                </div>

              </div>
            </div>
        </section>

        <!--==========================
            Contact Section
        ============================-->
        <section id="contact" class="padd-section wow fadeInUp">

            <div class="container">
            <div class="section-title text-center">
                <h2>Contato</h2>
                <p class="separator">Entre em contato para saber mais sobre nossa plataforma. Comece hoje seus estudos <router-link to="cadastro">cadastrar</router-link></p>
            </div>
            </div>

            <div class="container">
              <div class="row justify-content-center">

                  <div class="col-lg-3 col-md-4">

                    <img src="../assets/logo.png" alt="logo">

                  </div>

                  <div class="col-lg-5 col-md-8">
                    <div class="form">
                        <div id="sendmessage">Sua mensagem foi enviada. Obrigado!</div>
                        <div id="errormessage"></div>
                        <form action="" method="post" role="form" class="contactForm">
                        <div class="form-group">
                            <input type="text" name="name" class="form-control" id="name" placeholder="Your Name" data-rule="minlen:4" data-msg="Please enter at least 4 chars" />
                            <div class="validation"></div>
                        </div>
                        <div class="form-group">
                            <input type="email" class="form-control" name="email" id="email" placeholder="Your Email" data-rule="email" data-msg="Please enter a valid email" />
                            <div class="validation"></div>
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-control" name="subject" id="subject" placeholder="Subject" data-rule="minlen:4" data-msg="Please enter at least 8 chars of subject" />
                            <div class="validation"></div>
                        </div>
                        <div class="form-group">
                            <textarea class="form-control" name="message" rows="5" data-rule="required" data-msg="Please write something for us" placeholder="Message"></textarea>
                            <div class="validation"></div>
                        </div>
                        <div class="text-center"><button type="submit">ENVIAR</button></div>
                        </form>
                    </div>
                  </div>
              </div>
            </div>
        </section><!-- #contact -->

        <!--==========================
            Footer
        ============================-->
        <footer class="footer">
            <div class="container">
            <div class="row">

                <div class="col-md-12 col-lg-4">
                  <div class="footer-logo">

                      <a class="navbar-brand" href="#"><span class="nefro">NEFRO</span><span class="atlas">ATLAS</span></a>
                      <h4 style="color:white">Tire suas dúvidas!</h4>
                      <p class="text-justify">
                        Em qualquer momento dos seus estudos, nossa equipe poderá receber suas dúvidas através
                        do e-mail localizado na parte inferior desta página.
                      </p>

                  </div>
                </div>

                <div class="col-md-12 col-lg-4">
                  <div class="footer-logo">

                      

                  </div>
                </div>

                <div class="col-md-12 col-lg-4">
                  <div class="footer-logo">

                      <a href="" class="navbar-brand"></a>

                      <h4 style="color:white">Faça nossas questões!</h4>
                      <p class="text-justify">
                        Ao final de cada módulo teremos questões de exercício, com o único objetivo de promover a
                        auto-avaliação e ser utilizada como ferramenta para a aprendizagem. Não deixe de fazer
                        nossos exercícios!
                      </p>

                  </div>
                </div>



                <!-- <div class="col-sm-6 col-md-3 col-lg-2">
                  <div class="list-menu">

                      <h4>Abou Us</h4>

                      <ul class="list-unstyled">
                      <li><a href="#">About us</a></li>
                      <li><a href="#">Features item</a></li>
                      <li><a href="#">Live streaming</a></li>
                      <li><a href="#">Privacy Policy</a></li>
                      </ul>

                  </div>
                </div>

                <div class="col-sm-6 col-md-3 col-lg-2">
                  <div class="list-menu">

                      <h4>Support</h4>

                      <ul class="list-unstyled">
                      <li><a href="#">faq</a></li>
                      <li><a href="#">Editor help</a></li>
                      <li><a href="#">Contact us</a></li>
                      <li><a href="#">Privacy Policy</a></li>
                      </ul>

                  </div>
                </div> -->


            </div>
            </div>

            <div class="copyrights">
              <div class="container">
                  <p>2019 &copy; Copyrights <span class="nefro">Nefro</span><span class="atlas">Atlas</span>. All rights reserved.</p>
              </div>
            </div>

        </footer>



        <a href="#" class="back-to-top"><i class="fa fa-chevron-up"></i></a>



    </div>
</template>

<script>
import { LogInIcon, UserPlusIcon } from 'vue-feather-icons'
export default {
    components: {
      LogInIcon,
      UserPlusIcon
    }
}
</script>

<style scoped>

@charset "UTF-8";

/*--------------------------------------------------------------
# General
--------------------------------------------------------------*/
  body {
    background-color: #fff;
    color: #333;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }

  h2 {
    color: #000;
    font-weight: 100;
  }

  h4 {
    color: #000;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    line-height: 2;
  }

  h5 {
    color: #626262;
    font-size: 14px;
    font-weight: 500;
  }

  a {
    letter-spacing: 2px;
    text-decoration: none;
  }

  ul {
    letter-spacing: 1px;
  }

  li {
    color: #626262;
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 2px;
    line-height: 30px;

  }

  p {
    color: #505050;
    font-size: 14px;
    font-weight: 300;
    letter-spacing: 0.5px;
    line-height: 2;
    margin-bottom: 20px;
  }

  span {
    letter-spacing: 1px;
  }

  .border {
    border-radius: 10px;
  }
  .img-fluid {
    height: 60px;
    margin-bottom: 30px;
    width: 60px;
  }

  .container-full {
    padding-left: 0;
    padding-right: 0;
  }

  .btn {
    border: 1px solid #fff;
    border-radius: 50px;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    padding: 15px 40px;
    text-transform: uppercase;
    -moz-transition: all 0.5s ease-in-out 0s;
    -ms-transition: all 0.5s ease-in-out 0s;
    -o-transition: all 0.5s ease-in-out 0s;
    -webkit-transition: all 0.5s ease-in-out 0s;
    transition: all 0.5s ease-in-out 0s;
  }

  .btn-default:hover {
    color: #fff;
    background-color: #e6e6e6;
    border-color: #adadad;
  }

  /* Back to top button */
  .back-to-top {
    position: fixed;
    display: none;
    background: #71c55d;
    line-height: 1;
    color: #fff;
    padding: 7px 12px 13px 12px;
    font-size: 16px;
    border-radius: 2px;
    right: 15px;
    bottom: 15px;
    transition: background 0.5s;
  }

  @media (max-width: 768px) {
    .back-to-top {
      bottom: 15px;
    }
  }

  .back-to-top:focus {
    background: #71c55d;
    color: #fff;
    outline: none;
  }

  .back-to-top:hover {
    background: #55b03f;
    color: #fff;
  }

  /*--------------------------------------------------------------
  # Header
  --------------------------------------------------------------*/
  #header {
    background: #fff;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    height: 48px;
    z-index: 3;
    transition: all 0.5s ease;
  }

  #header #logo {
    padding: 6px 0 0 0;
  }

  #header #logo {
    color: #505050;
    font-family: "Philosopher", sans-serif;
    font-size: 26px;
    font-weight: 500;
    letter-spacing: 1px;
    margin: 0;
  }

  #header #logo a {
    color: #41ce8e ;
    line-height: 1;
    display: inline-block;
    text-decoration: none;
  }

  #header #logo a span {
    color: #2cb5e8;
  }

  #header #logo img {
    padding: 0;
    margin: 0;
  }

  .scroll-header {
    background: #fff;
    box-shadow: 0 3px 7px rgba(0, 0, 0, 0.1);
  }

/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
  #hero {
    width: 100%;
    height: calc(100vh - 40px);
    background: url(../assets/hero-bg.png) center bottom no-repeat;
    background-size: 100%;
    position: relative;
    margin-top: 40px;
  }
  .plataforma {
    text-decoration: line-through!important;
  }

  @media (min-width: 1025px) {
    #hero {
      background-attachment: fixed;
    }
  }
  
  
  #hero .hero-container {
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
  }

  #hero h1 {
    margin: 0 0 10px 0;
    font-size: 40px;
    font-weight: 700;
    line-height: 50px;
    font-family: "Philosopher", sans-serif;
    color: #2c3e50;
  }

  @media (max-width: 768px) {
    #hero h1 {
      font-size: 28px;
      line-height: 36px;
    }
  }

  #hero h2 {
    color: #777;
    margin-bottom: 30px;
    font-size: 20px;
    font-family: "Roboto", sans-serif;
    font-weight: 300;
  }

  @media (max-width: 768px) {
    #hero h2 {
      font-size: 18px;
      line-height: 24px;
      margin-bottom: 30px;
    }
  }

  #hero img {
    max-width: 95%;
    margin-bottom: 30px;
  }

  #hero .btn-get-started {
    font-family: "Roboto", sans-serif;
    text-transform: uppercase;
    font-weight: 400;
    font-size: 13px;
    letter-spacing: 1px;
    display: inline-block;
    padding: 11px 36px;
    border-radius: 50px;
    transition: 0.5s;
    margin-bottom: 30px;
    border: 2px solid #71c55d;
    background: #fff;
    color: #71c55d;
    text-decoration: none;
  }

  #hero .btn-get-started:hover {
    background: #71c55d;
    color: #fff;
  }

  #hero .btns a {
    color: #555;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    margin: 4px 20px;
    text-decoration: none;
    transition: 0.3s;
  }

  @media (max-width: 575px) {
    #hero .btns a {
      margin: 4px 15px;
    }
  }
  @media (min-width: 375px) {
    #hero .btns a {
      margin: 4px 25px;
    }
  }
  @media (min-width: 425px) {
    #hero .btns a {
      margin: 4px 35px;
    }
  }

  #hero .btns a:hover {
    color: #71c55d;
  }

  @media (min-width: 768px) {
    #hero .hero-container {
      top: 20px;
    }
    #hero .hero-img {
      width: 60%
    }
  }
  @media (min-width: 1200px) {
    #hero .hero-img {
      width: 40%;
    }
  }
  @media screen and (min-width: 1440px) {
    #hero .hero-container {
      top: 10px;
    }
    #hero .hero-img {
      width: 50%
    }
  }

/*--------------------------------------------------------------
# Navigation Menu
--------------------------------------------------------------*/
/* Nav Menu Essentials */
.nav-menu, .nav-menu * {
  margin: 0;
  padding: 0;
  list-style: none;
  background-color: white
}

.nav-menu ul {
  position: absolute;
  display: none;
  top: 100%;
  left: 0;
  z-index: 99;
}

.nav-menu li {
  position: relative;
  white-space: nowrap;
}

.nav-menu > li {
  float: left;
}

.nav-menu li:hover > ul,
.nav-menu li.sfHover > ul {
  display: block;
}

.nav-menu ul ul {
  top: 0;
  left: 100%;
}

.nav-menu ul li {
  min-width: 180px;
}


/* Nav Meu Container */
#nav-menu-container {
  position: relative;
  float: right;
  top: -40px;
  margin: 0 0 0 0;
}

@media (max-width: 1024px) {
  #nav-menu-container {
    display: initial;
  }
}

/* Nav Meu Styling */
.nav-menu a {
  padding: 8px 8px;
  text-decoration: none;
  display: inline-block;
  color: #555;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 14px;
  outline: none;
  letter-spacing: 0;
  transition: 0.3s;
}

.nav-menu li:hover > a, .nav-menu > .menu-active > a {
  color: #71c55d;
}

.nav-menu > li {
  margin-left: 10px;
}

.nav-menu ul {
  margin: 0;
  padding: 10px;
  box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);
  background: #fff;
}

.nav-menu ul li {
  transition: 0.3s;
}

.nav-menu ul li a {
  padding: 5px 10px;
  color: #333;
  transition: 0.3s;
  display: block;
  font-size: 14px;
  text-transform: none;
}

.nav-menu ul li:hover > a {
  color: #71c55d;
}

.nav-menu ul ul {
  margin: 0;
}

 .active {
     color: #41ce8e!important; 
  }


/*--------------------------------------------------------------
# Sections
--------------------------------------------------------------*/
.padd-section {
  padding-bottom: 80px;
  /* padding-top: 80px; */
}

@media (max-width: 992px) {
  .padd-section {
    padding-top: 40px;
    /* padding-bottom: 40px; */
  }
}

.section-title {
  margin-bottom: 80px;
}

@media (max-width: 992px) {
  .section-title {
    margin-bottom: 40px;
  }
}

.section-title h2 {
  font-family: "Roboto", sans-serif;
  font-size: 45px;
  font-weight: 100;
  letter-spacing: 2px;
  margin-bottom: 20px;
}

.section-title .separator {
  margin: 0;
}

.separator {
  color: #626262;
  font-family: "Roboto", sans-serif;
  font-size: 15px;
  font-weight: 300;
  margin-bottom: 30px;
}

/* Get Started Section
--------------------------------*/
#get-started {
  display: inline-block;
  height: 100%;
  width: 100%;
}

#get-started .feature-block {
  background: #fff none repeat scroll 0 0;
  padding: 30px 20px;
  transition: all 0.5s ease-in-out 0s;
  border-radius: 20px
}

@media (max-width: 991px) {
  #get-started .feature-block {
    margin-bottom: 30px;
  }
}

#get-started .feature-block:hover {
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
  transition: all 0.5s ease-in-out 0s;
}

#get-started .feature-block h4 {
  margin-bottom: 20px;
}

#get-started .feature-block p {
  margin-bottom: 20px;
}

#get-started .feature-block a {
  color: #505050;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  transition: 0.3s;
}

#get-started .feature-block a:hover {
  color: #71c55d;
}

/* About Us Section
--------------------------------*/
#about-us img {
  max-width: 100%;
}

#about-us .about-content {
  padding-top: 60px;
}

#about-us .about-content h2 {
  color: #252525;
  font-family: "roboto";
  font-size: 39px;
  font-weight: 100;
  letter-spacing: 2px;
  margin-bottom: 20px;
}

#about-us .about-content span {
  font-weight: 700;
  padding-right: 10px;
  text-transform: uppercase;
}

#about-us .about-content ul li {
  line-height: 36px;
}

#about-us .about-content ul li .fa {
  padding-right: 20px;
}

/* Features Section
--------------------------------*/
#features {
  display: inline-block;
  height: 100%;
  width: 100%;
}

#features .feature-block {
  background: #fff none repeat scroll 0 0;
  padding: 30px 20px;
  margin-bottom: 30px;
  transition: all 0.5s ease-in-out 0s;
  border-radius: 10px
}

#features .feature-block:hover {
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
  transition: all 0.5s ease-in-out 0s;
}

#features .feature-block h4 {
  margin-bottom: 20px;
}

#features .feature-block p {
  margin-bottom: 0;
}


/* Team Section
--------------------------------*/
#team .team-block {
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
  height: 254px;
  overflow: hidden;
  position: relative;
  width: 100%;
  margin-bottom: 20px;
}

@media (max-width: 991px) {
  #team .team-block {
    margin-bottom: 30px;
  }
}

#team .team-block img {
  width: 100%;
  height: 100%;
  padding: 50px;
}

#team .team-block .team-content {
  background: #fff none repeat scroll 0 0;
  bottom: 0;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.19);
  bottom: -147px;
  padding: 20px 0;
  position: absolute;
  width: 100%;
  transition: all 0.5s ease-in-out 0s;
}

#team .team-block .team-content ul {
  display: block;
  width: 100%;
}

#team .team-block .team-content ul li {
  display: inline-block;
}

#team .team-block .team-content ul li a {
  color: #626262;
}

#team .team-block .team-content ul li a .fa {
  float: left;
  padding-left: 10px;
  padding-right: 10px;
  transition: 0.3s;
}

#team .team-block .team-content ul li a .fa:hover {
  color: #71c55d;
}

#team .team-block .team-content ul > span {
  display: inline-block;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 0.5px;
  margin-bottom: 20px;
  text-transform: uppercase;
}

#team .team-block:hover .team-content {
  bottom: 0px;
  transition: all 0.5s ease-in-out 0s;
}



/* Contact Section
--------------------------------*/
#contact {
  background: #fff;
}

#contact .info {
  color: #222;
}

#contact .info i {
  font-size: 32px;
  color: #71c55d;
  float: left;
}

#contact .info p {
  padding: 0 0 10px 50px;
  margin-bottom: 20px;
  line-height: 22px;
  font-size: 14px;
}

#contact .info .email p {
  padding-top: 5px;
}

#contact .social-links {
  padding-bottom: 20px;
}

#contact .social-links a {
  font-size: 18px;
  display: inline-block;
  background: #71c55d;
  color: #fff;
  line-height: 1;
  padding: 6px 0 8px 0;
  border-radius: 50%;
  text-align: center;
  width: 36px;
  height: 36px;
  transition: 0.3s;
}

#contact .social-links a:hover {
  background: #55b03f;
  color: #fff;
}

#contact .form #sendmessage {
  color: #71c55d;
  border: 1px solid #71c55d;
  display: none;
  text-align: center;
  padding: 15px;
  font-weight: 600;
  margin-bottom: 15px;
}

#contact .form #errormessage {
  color: red;
  display: none;
  border: 1px solid red;
  text-align: center;
  padding: 15px;
  font-weight: 600;
  margin-bottom: 15px;
}

#contact .form #sendmessage.show, #contact .form #errormessage.show, #contact .form .show {
  display: block;
}

#contact .form .validation {
  color: red;
  display: none;
  margin: 0 0 20px;
  font-weight: 400;
  font-size: 13px;
}

#contact .form input, #contact .form textarea {
  border-radius: 0;
  box-shadow: none;
  font-size: 14px;
  padding: 12px 10px;
  line-height: 1;
}

#contact .form button[type="submit"] {
  background: #71c55d;
  border: 0;
  padding: 10px 24px;
  color: #fff;
  transition: 0.4s;
}

#contact .form button[type="submit"]:hover {
  background: #92d283;
}

/*--------------------------------------------------------------
# Footer
--------------------------------------------------------------*/
.footer {
  background: #2a2c30;
  padding-top: 50px;
}

.footer .footer-logo .navbar-brand {
  color: #fff;
  display: inline-block;
  float: none;
  font-family: "Philosopher", sans-serif;
  font-size: 24px;
  font-weight: 500;
  height: 100%;
  letter-spacing: 0.2em;
  padding-left: 0;
  padding-top: 0;
}

.footer .footer-logo p {
  color: #fff;
  font-size: 12px;
  letter-spacing: 1px;
}

.footer .list-menu > h4 {
  color: #fff;
  padding-bottom: 20px;
}

.footer .list-menu ul li a {
  color: #fff;
  font-size: 12px;
  padding-left: 5px;
  text-decoration: none;
  letter-spacing: 0;
}

.footer .copyrights {
  background: #fff;
  margin-top: 50px;
  text-align: center;
  padding: 25px;
}

.footer .copyrights p, .footer .copyrights .credits {
  margin: 0;
  padding: 0;
  font-family: "Open Sans", sans-serif;
  font-weight: normal;
  font-size: 14px;
  letter-spacing: 0;
}

.footer .copyrights p a, .footer .copyrights .credits a {
  letter-spacing: 0;
  color: #71c55d;
}



</style>